module.exports = __webpack_public_path__ + "static/img/brand_5@2x.4c4652c3.png";